import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-national-modal',
  templateUrl: './national-modal.component.html',
  styleUrls: ['./national-modal.component.scss']
})
export class NationalModalComponent implements OnInit {

  isLoading = true;
  Errors = null;
  titles = null;
  mode = null;
  countries = null
  data = null
  Success = null

  stateForm = new FormGroup({
    name: new FormControl('', Validators.required),
    id: new FormControl(null, Validators.required),
  });

  constructor(public auth: SettingsService, private modal: ModalService, private _snackBar: MatSnackBar) { }

  onSubmit(e) {
    e.preventDefault();
    this.isLoading = true;
    this.Errors = null;
    this.Success = null;
    const {
      id,
      name,
    } = this.stateForm.value;
    this.auth
      .postNation(
        id,
        name,
      )
      .subscribe(
        (resSuccess) => {

          this.data = resSuccess
          this.isLoading = false;

          if (this.data.success) {
            this.closeModal()
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });          }
          else {
            this.Errors = "Not successful, please try again"
            console.log("error")
          }
          
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr)
        }
      );
  }

  ngOnInit(): void {

    this.auth
      .getNation()
      .subscribe(
        (resSuccess) => {

          this.titles = resSuccess
          this.isLoading = false;
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        } 
      );
  }

  addNew() {
    this.mode = "add"
  }
  edit(title) {
    this.mode = "edit"
    this.stateForm.patchValue({
      name: title.name,
      id: title.id,
    });
    console.log(this.stateForm.value)
  }
  closeModal() {
    this.modal.closeModal();
  }

  delete(title) {
    this.auth
      .delSet("/api/geography/national/delete", title.id)
      .subscribe(
        (resSuccess) => {
          this.titles = this.titles.filter(dattum => dattum.id !== title.id)
          this._snackBar.open('Deleted Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        },
        (resErr) => {
          this._snackBar.open('Error try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      );
  }

}
